import React from "react";

import countriesFlags from "./countryFlag/countriesFlags";

export const CountryFlag = ({ isoCountryCode, label }) => {
  return <img src={countriesFlags[isoCountryCode.toUpperCase()]} alt="flag" />;
};



// WEBPACK FOOTER //
// ./src/newDropshipperApp/spocketUI/components/CountryFlag.js